import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nService } from './i18n.service';
import { BrandModule } from '../brand/brand.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, BrandModule],
  providers: [I18nService]
})
export class I18nModule {}
